import React, { FC, ReactNode } from 'react';
import { Dialog, DialogProps, useTheme } from '@mui/material';
import { PaperProps } from '@mui/material/Paper';

import { ModalFooter, ModalFooterProps } from './ModalFooter';
import { ModalHeader, ModalHeaderProps } from './ModalHeader';
import './Modal.styles.scss';

type VariantType = 'default' | 'success' | 'error' | 'warning' | 'info' | 'muted' | 'danger' | 'pending';

interface Props {
  open: boolean;
  onClose: () => void | Promise<void>;
  children: ReactNode;
  modalHeaderProps?: ModalHeaderProps;
  modalFooterProps?: ModalFooterProps;
  type?: VariantType;
  sx?: PaperProps['sx'];
  _container?: DialogProps['sx'];
}

export const Modal: FC<Props> = ({
  children,
  open,
  onClose,
  modalHeaderProps,
  modalFooterProps,
  type,
  sx,
  _container,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      onClose={onClose}
      open={open}
      sx={_container}
      PaperProps={{ elevation: 1, sx }}
      classes={{ paper: `py-4 ps-4 modal-wrapper ${theme.palette.mode} ${type ? `modal-border ${type}` : ''}` }}
    >
      {modalHeaderProps && <ModalHeader {...modalHeaderProps} />}
      <div className="modal-body pe-4">{children}</div>
      {modalFooterProps && <ModalFooter {...modalFooterProps} />}
    </Dialog>
  );
};
